import styled from 'styled-components/macro';
import size from 'utils/scale-size';
import scaleSize from 'utils/scale-size';
import { FocusableParent } from 'components/navigation';
import Button from 'components/Button';

const PAGE_HEIGHT = size(1080);
const TITLE_HEIGHT = size(140);
const CONTENT_HEIGHT = PAGE_HEIGHT - TITLE_HEIGHT;

export const StyledPage = styled.div`
  width: ${size(1920)}px;
  height: ${PAGE_HEIGHT}px;
`;

export const StyledPageLayout = styled.div`
  margin: 0 ${size(220)}px;
`;

export const StyledPageTitle = styled.div`
  height: ${TITLE_HEIGHT}px;
  padding-top: ${size(55)}px;
  box-sizing: border-box;
  font-size: ${size(48)}px;
  line-height: ${size(1.5, false)};
  letter-spacing: -0.33px;
  color: ${({ theme }) => theme.defaultColor};
  text-align: ${({ left }) => (left ? 'left' : 'center')};
`;

export const StyledPageContent = styled.div`
  height: ${CONTENT_HEIGHT}px;
  width: 100%;
  display: table;
`;

export const StyledCenteredBlock = styled.div`
  display: table-cell;
  vertical-align: middle;
  text-align: center;
`;

export const StyledLanguageButtonsGroup = styled(FocusableParent)`
  display: inline-block;
  margin-top: -${TITLE_HEIGHT}px;
`;

export const StyledLanguageButton = styled(Button)`
  min-width: ${scaleSize(400)}px;
  height: ${scaleSize(80)}px;
  font-size: ${scaleSize(34)}px;
  line-height: ${scaleSize(80)}px;
  padding-left: ${scaleSize(40)}px;
  margin-bottom: ${scaleSize(15)}px;
  color: ${({ theme, selected }) => (selected ? theme.activeColor : theme.mainTextColor)};
  box-sizing: border-box;
  border-radius: ${scaleSize(12)}px;
  border: none;
  text-align: left;
  display: block;
  position: relative;
  font-family: RobotoMedium, sans-serif;

  & > svg {
    display: ${({ selected }) => (selected ? 'inline-block' : 'none')};
    padding-left: ${scaleSize(20)}px;

    path {
      stroke: ${({ theme }) => theme.activeColor};
      fill: none;
    }
  }

  &:focus {
    background-color: ${({ theme }) => theme.activeColor};
    color: ${({ theme }) => theme.activeColorText};

    svg > path {
      stroke: ${({ theme }) => theme.activeColorText};
      fill: none;
    }
  }
`;
